import { NavigationMenuList } from "@/components/ui/NavigationMenu";
import React from "react";
import { DesktopSubMenu } from "./shared/DesktopSubMenu";
import { CompanySubMenu } from "./subnav/CompanySubMenu";
import { PlatformSubMenu } from "./subnav/PlatformSubMenu";
import { ResourcesSubMenu } from "./subnav/ResourcesSubMenu";
import { ShopSubMenu } from "./subnav/ShopSubMenu";
import { SolutionsSubMenu } from "./subnav/SolutionsSubMenu";

export const DesktopNavigation = ({
  className,
}: {
  readonly className?: string;
}) => (
  <NavigationMenuList className={className}>
    <PlatformSubMenu wrapperComponent={DesktopSubMenu} />
    <SolutionsSubMenu wrapperComponent={DesktopSubMenu} />
    <ShopSubMenu wrapperComponent={DesktopSubMenu} />
    <ResourcesSubMenu wrapperComponent={DesktopSubMenu} />
    <CompanySubMenu wrapperComponent={DesktopSubMenu} />
  </NavigationMenuList>
);
